

import { types } from 'mobx-state-tree';

export const RangeLabelModel = types.model('RangeLabelModel', {
  name: types.string,
});

